import React from "react";

const SmallBusinessIcon = ({
  selected, 
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        x="1"
        y="3.66699"
        width="22"
        height="19.3333"
        rx="1"
        stroke= {selected ? "#207C97" :  "currentColor"}
        strokeWidth="2"
      />
      <rect
        x="8.63672"
        y="1"
        width="13.2727"
        height="2.44444"
        rx="1"
        stroke= {selected ? "#207C97" :  "currentColor"}
        strokeWidth="2"
      />
      <rect
        x="10"
        y="23"
        width="8"
        height="5"
        rx="1"
        transform="rotate(-90 10 23)"
        stroke= {selected ? "#207C97" :  "currentColor"}
        strokeWidth="2"
      />
      <rect
        x="4"
        y="11"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 4 11)"
        stroke= {selected ? "#207C97" :  "currentColor"}
        strokeWidth="2"
      />
      <rect
        x="11"
        y="11"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 11 11)"
        stroke= {selected ? "#207C97" :  "currentColor"}
        strokeWidth="2"
      />
    </svg>
  );
};

export default SmallBusinessIcon;
